import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export default class TmAuthSignUpForbiddenError extends TmAuthError {}
